import React from 'react';

const AppContext = React.createContext();

const AppProvider = ({ children, isTouch, currency }) => (
    <AppContext.Provider value={{isTouch, currency}}>
        {children}
    </AppContext.Provider>
);

export {
    AppProvider,
    AppContext
};
